import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {paypalDescription, type PayPalGateway} from './paypal';
import venmoBadgeURL from '../../../img/badge/venmo.svg';
import venmoImageURL from '../../../img/marks/venmo.svg';
import {type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../../@type/features';
import {Feature} from '../../reducers/environmentReducer';
import {PayPalPaymentButton} from './class-paypal-payment';
import {render} from '../../reducers/rootReducer';
import {store} from '../../store';

function initPayPalVenmoMethod(): PayPalGateway {
	let buttonInstance: PayPalPaymentButton | null = null;

	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.PAYPAL_VENMO_GATEWAY, 'title') ?? 'Venmo',
		gatewayId: 'peachpay_paypal_venmo',
		description: paypalDescription('Venmo', venmoImageURL, 'After selecting the Venmo button you will be prompted to complete your payment.'),
		assets: {
			badge: {src: venmoBadgeURL},
			title: {src: venmoImageURL},
		},
	};

	return {
		config,
		activate(paypal, orderService) {
			buttonInstance = new PayPalPaymentButton(paypal, orderService, {
				gatewayId: 'peachpay_paypal_venmo',
				fundingType: 'venmo',
				buttonStyle: Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_VENMO_GATEWAY, 'button_style') ?? undefined,
			});
			config.initialized = buttonInstance.isEligible();
			store.dispatch(render());
		},
		reset() {
			buttonInstance?.unmount();
			buttonInstance = null;
			config.initialized = false;
			store.dispatch(render());
		},
		attach(selector) {
			buttonInstance?.mount(selector);
		},
		detach() {
			buttonInstance?.unmount();
		},
	};
}

export {
	initPayPalVenmoMethod,
};
